import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { toast } from 'react-hot-toast';
import ModalCarga from '../ModalCarga';

class RegistrosPan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            tipo: 'registro',
            data: [],
            registroPanSeleccionado: [],
        }
    }

    componentDidMount = async () => {
        this.select();
    }

    componentDidUpdate = (prevProps) => {
        if ((prevProps.idSucursal !== this.props.idSucursal) || (prevProps.fecha !== this.props.fecha)) {
            this.select()
            this.setState({
                registroPanSeleccionado: []
            })
        }
    }

    numberWithCommas = (x) => {
        x = Number(x).toFixed(2);
        if (x === 0) {
            return '0.00';
        }else{
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }

    select = async () => {  
        this.setState({ loading: true });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'registrosPan', idSucursal: this.props.idSucursal, fecha: this.props.fecha })
        };
        const response = await fetch('https://admin.panaderialazcano.com/php/DB/reportes.php', requestOptions);
        const data = await response.json();
        console.log(data);
        if (data.error === 0) {
            this.setState({
                data: data,
                loading: false
            })
        }else{
            this.setState({
                loading: false
            })
            toast.error('Error al obtener datos');
            console.log(data.mensaje);
        }
    }

    selectRegistro = async (e) => {
        this.setState({ loading: true });
        let idRegistroPan = e.target.id;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'selectRegistroPan', idRegistroPan: idRegistroPan })
        };
        const response = await fetch('https://admin.panaderialazcano.com/php/DB/reportes.php', requestOptions);
        const data = await response.json();
        console.log(data);
        if (data.error === 0) {
            this.setState({
                registroPanSeleccionado: data,
                loading: false
            })
        }else{
            this.setState({
                loading: false
            })
            toast.error('Error al obtener datos');
            console.log(data.mensaje);
        }
    }

    onChangeValue = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    

    render() { 
        return ( 
            <>
                <ModalCarga show={this.state.loading}/>
                <div className="col-2">
                    <label className='ms-1' htmlFor="tipo">Tipo</label>
                    <select name="tipo" id="tipo" className='form-control' value={this.state.tipo} onChange={this.onChangeValue}>
                        <option value="dia">Por Dia</option>
                        <option value="registro">Por Registro</option>
                    </select>
                </div>
                <div className="col-12 mt-5"/>
                {
                    (this.state.tipo === 'dia' && this.state.data.porDia) &&
                        <div className="col-6 mx-auto">
                            <Table bordered striped>
                                <thead className='bg-black text-white'>
                                    <tr>
                                        <th>ID Del Producto</th>
                                        <th>Producto</th>
                                        <th>Cantidad Registrada</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.data.porDia &&
                                            this.state.data.porDia.map((e) =>                                            
                                            <tr key={e.idProducto}>
                                                <td className='text-center'>{e.idProducto}</td>
                                                <td className='w-50'>{e.nombre}</td>
                                                <td className='text-end'>{e.total_registrado}</td>
                                            </tr>                                            
                                    )
                                    }
                                </tbody>
                            </Table>
                        </div>
                }
                {
                     (this.state.tipo === 'registro' && this.state.data.porRegistro) &&
                     <>
                        <div className="col-3 mb-4 mx-auto" style={{ maxHeight: '656px', overflowY: 'auto' }}>
                            <Table bordered striped>
                                <thead className='bg-black text-white' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                    <tr>
                                        <th>Hora</th>
                                        <th>Piezas</th>
                                        <th>Usuario</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.data.porRegistro &&
                                            this.state.data.porRegistro.map((e) =>                                            
                                            <tr key={e.idRegistroPan} id={e.idRegistroPan} onClick={this.selectRegistro} style={{ fontWeight: this.state.registroPanSeleccionado.idRegistroPan === e.idRegistroPan ? 'bold' : '' }}>
                                                <td className='text-center' id={e.idRegistroPan}>{new Date(e.fecha).toLocaleTimeString()}</td>
                                                <td className='text-end' id={e.idRegistroPan}>{e.piezas}</td>
                                                <td className='' id={e.idRegistroPan}>{e.usuario}</td>
                                            </tr>                                            
                                    )
                                    }
                                </tbody>
                            </Table>
                        </div>
                        <div className="col-7 mb-4 mx-auto" style={{ maxHeight: '656px', overflowY: 'auto' }}>
                            {
                                this.state.registroPanSeleccionado.idRegistroPan ?
                                    <Table striped>
                                        <thead className='bg-black text-white' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                            <tr>
                                                <th className='text-center' colSpan={3}>Detalles del registro</th>
                                            </tr>
                                            <tr>
                                                <th className='text-center col-4'>Hora</th>
                                                <th className='text-center col-4'>Usuario</th>
                                                <th className='text-center col-4'>Total de piezas</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th className='text-center'>{new Date(this.state.registroPanSeleccionado.fecha).toLocaleTimeString()}</th>
                                                <th className='text-center'>{this.state.registroPanSeleccionado.usuario}</th>
                                                <th className='text-center'>{this.state.registroPanSeleccionado.piezas}</th>
                                            </tr>
                                            <tr className='table-group-divider'></tr>
                                            {
                                                this.state.registroPanSeleccionado.productos.map((e) =>                                            
                                                    <tr key={e.idProductoRegistroPan}>
                                                        <td className='' colSpan={2}>{e.nombre}</td>
                                                        <td className='text-center'>{e.cantidad}</td>
                                                    </tr>                                            
                                                    )
                                            }
                                        </tbody>
                                    </Table>
                                :
                                <h1 className='text-center'>Seleccione un registro para ver el detalle</h1>
                            }
                        </div>
                    </>
                }
            </>
         );
    }
}
 
export default RegistrosPan;